"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPrefixToAddInfoSchemaKeys = exports.stripNonSharedSections = exports.transformSchemaKeys = void 0;
exports.formatCostString = formatCostString;
exports.formatValueAsDecimal = formatValueAsDecimal;
const logging_1 = require("./logging");
/**
 * @description formats a number or number string as a currency with the currency symbol
 * @currency the currency of the cost itself
 * @locale the locale of the user viewing the currency, defaults to navigator.language
 * @returns formatted cost string with currency symbol
 */
function formatCostString(amount, currency, locale) {
    try {
        const value = Number(amount);
        if (isNaN(value)) {
            (0, logging_1.spLogTags)('Error invalid cost value', ['ERROR', 'formatting']);
            return '';
        }
        else if (currency === 'CO2e') {
            let formattedCost = '';
            switch (currency) {
                case 'CO2e':
                    formattedCost = new Intl.NumberFormat(locale ?? navigator.language).format(value);
                    return formattedCost + ' t (CO₂e)';
                default:
                    formattedCost = new Intl.NumberFormat(locale ?? navigator.language).format(value);
                    return formattedCost;
            }
        }
        else {
            const formattedCost = new Intl.NumberFormat(locale ?? navigator.language, {
                style: 'currency',
                currency,
            }).format(value);
            return formattedCost;
        }
    }
    catch {
        (0, logging_1.spLogTags)('Error invalid cost value', ['ERROR', 'formatting']);
        return '';
    }
}
/**
 * @description formats a number or number string as a decimal with minimum 2 decimal places
 * @locale the locale of the user viewing the number, defaults to navigator.language
 * @returns formatted number string or 0.00
 */
function formatValueAsDecimal(value, locales, useGrouping) {
    try {
        const numValue = Number(value);
        if (!isNaN(numValue)) {
            const formattedValue = new Intl.NumberFormat(locales ?? navigator.language, {
                style: 'decimal',
                minimumFractionDigits: 2,
                useGrouping: useGrouping ?? true,
            }).format(numValue);
            return formattedValue;
        }
        else {
            (0, logging_1.spLogTags)('value is not a number', ['parse'], value);
            return '0.00';
        }
    }
    catch (err) {
        (0, logging_1.spLogTags)('Error, parsing exception found', ['ERROR', 'parse'], err);
        return '0.00';
    }
}
const transformSchemaKeys = (obj) => Object.fromEntries(Object.entries(obj).map(([key, value]) => {
    const prefixes = ['section_', 'field_'];
    const newKey = prefixes.reduce((k, prefix) => k.replace(new RegExp(`^${prefix}`), ''), key);
    const newValue = Array.isArray(value)
        ? value.map((item) => typeof item === 'object' &&
            item !== null &&
            !(item instanceof Date)
            ? (0, exports.transformSchemaKeys)(item)
            : item)
        : typeof value === 'object' &&
            value !== null &&
            !(value instanceof Date)
            ? (0, exports.transformSchemaKeys)(value)
            : value;
    return [newKey, newValue];
}));
exports.transformSchemaKeys = transformSchemaKeys;
const stripNonSharedSections = (obj, sharedFields) => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => sharedFields.includes(key)));
};
exports.stripNonSharedSections = stripNonSharedSections;
const addPrefixToAddInfoSchemaKeys = (obj) => {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => {
        const newKey = `section_${key}`;
        const newValue = typeof value === 'object' && value !== null
            ? Object.fromEntries(Object.entries(value).map(([fieldKey, fieldValue]) => {
                const newFieldKey = `field_${fieldKey}`;
                return [newFieldKey, fieldValue];
            }))
            : value;
        return [newKey, newValue];
    }));
};
exports.addPrefixToAddInfoSchemaKeys = addPrefixToAddInfoSchemaKeys;
